import React from "react"

function NoOrganizationMessage({ email }: { email: string }) {
  return (
    <>{`The email you provided "${email}" does not appear to represent an investment company.   In order to use this email, an ODC associate will need to setup your account.   We will email you with further information`}</>
  )
}

export default NoOrganizationMessage
